import { FileUploadService } from "@/core";

/**
 * 自定义上传图片插件
 */
class HmdUploadAdapter {
  loader: any;
  constructor(loader) {
    this.loader = loader;
  }

  async upload() {
    const file = await this.loader.file
    const url = await FileUploadService.uploadToOss(file);
    return {
      default: url,
    };
  }
}

export default HmdUploadAdapter;

